module.exports = __webpack_public_path__ + "close-16.fd13b063.svg";